import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AllowanceChipList } from "@/components/Product/AllowanceChipList";
import Image from "@/components/common/Image";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Sizes, UCILogo } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Button, Row } from "antd";
import dayjs from "dayjs";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { isBooksProduct } from "src/api/booksProducts";
import { SourceTypeWithString } from "src/api/product";
import { useModal } from "src/utils/overlay";
import { useTheme } from "styled-components";
import { AllowanceInfo, ContentInfo, CoreSection, ImageSection, ProductDetailInfoWrapper, StickySection, UCIPromotionBox } from "../../styles/ProductDetail.style";
import getPreviewImage from "../../utils/getPreviewImage";
import BooksBadge from "./BooksBadge";
import coreInfoList from "./coreInfoList";
const ProductDetailInfo = (props)=>{
    var _product_source, _product_source1, _product_source_object;
    const [_, { open: openPreviewModal  }] = useModal("preview-modal");
    const product = props.product;
    const productType = isBooksProduct(product) ? product.productType : product.source_type;
    const isBooks = isBooksProduct(product);
    const thumbImg = isBooks ? product.thumbImg : product.thumb_img;
    const { uciCode , publisherName , brandName  } = product;
    // TODO: remove this
    const { width  } = useWindowDimensions();
    const isMobile = width < 768;
    // theme
    const theme = useTheme();
    const router = useRouter();
    return /*#__PURE__*/ _jsx(ProductDetailInfoWrapper, {
        children: /*#__PURE__*/ _jsxs(Row, {
            children: [
                /*#__PURE__*/ _jsxs(ImageSection, {
                    className: "new-col",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "img_box",
                            children: /*#__PURE__*/ _jsx(Image, {
                                className: "thumb-img",
                                src: thumbImg,
                                alt: "product-thumbImg-".concat(product.title),
                                width: 330,
                                height: 440
                            })
                        }),
                        !isBooks && getPreviewImage(product).length > 0 && /*#__PURE__*/ _jsx(Button, {
                            className: "preview-btn",
                            onClick: ()=>{
                                openPreviewModal();
                                mixpanelEvent("Product Detail Page_Preview");
                            },
                            children: "미리보기"
                        }),
                        isBooks && /*#__PURE__*/ _jsx(BooksBadge, {}),
                        uciCode && /*#__PURE__*/ _jsxs(UCIPromotionBox, {
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    icon: UCILogo,
                                    size: isMobile ? Sizes.small : Sizes.large
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: uciCode
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "hide_m",
                                            children: "해당 자료는 국가콘텐츠식별체계를 통해 유통 및 관리됩니다."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(CoreSection, {
                    className: "new-col",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            children: [
                                SourceTypeWithString[productType],
                                " ",
                                isBooks ? /*#__PURE__*/ _jsx("span", {
                                    children: dayjs(product.publishedAt).format("YYYY년 개정판")
                                }) : (productType === "textbook" || productType === "workbook") && /*#__PURE__*/ _jsx("span", {
                                    children: product.published_at && dayjs(product.published_at).format("YYYY년 출간")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("h1", {
                            children: product.title
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "authorContainer",
                            children: [
                                product.author,
                                brandName && /*#__PURE__*/ _jsxs(Link, {
                                    onClick: ()=>mixpanelEvent("Product Detail Page Lab Button Clicked", {
                                            "Lab Button Proposition": "Top Section"
                                        }),
                                    href: "/@".concat(brandName),
                                    className: "author-nickname",
                                    children: [
                                        "브랜드",
                                        /*#__PURE__*/ _jsx(Icon, {
                                            icon: ArrowRight,
                                            size: Sizes.xsmall,
                                            color: theme.new.colors.sol_gray_600
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ContentInfo, {
                            children: coreInfoList(product, isBooks ? product.publisher : publisherName).map((item, idx)=>{
                                if (item.value == 0 || !item.value) {
                                    return;
                                }
                                return /*#__PURE__*/ _jsxs("li", {
                                    className: "core-info-" + productType,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "type",
                                            children: item.type
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "type-value ".concat(item.type),
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    onClick: ()=>{
                                                        if (item.link) {
                                                            router.push(item.link);
                                                        }
                                                    },
                                                    children: item.value
                                                }),
                                                item.link && /*#__PURE__*/ _jsx(Icon, {
                                                    icon: ArrowRight,
                                                    size: Sizes.xsmall,
                                                    color: theme.new.colors.sol_gray_600
                                                })
                                            ]
                                        })
                                    ]
                                }, "core-info" + idx);
                            })
                        }),
                        !isBooks && /*#__PURE__*/ _jsx(AllowanceInfo, {
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "activity",
                                children: [
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "desc-title",
                                        children: [
                                            isBooks ? "도서" : productType === "handout" ? "수업자료" : "라이선스",
                                            " 이용 범위"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "allowance-wrapper",
                                        children: /*#__PURE__*/ _jsx(AllowanceChipList, {
                                            productType: productType,
                                            studioVersion: (_product_source = product.source) === null || _product_source === void 0 ? void 0 : _product_source.studio_version,
                                            isParsedByMl: (_product_source1 = product.source) === null || _product_source1 === void 0 ? void 0 : (_product_source_object = _product_source1.object) === null || _product_source_object === void 0 ? void 0 : _product_source_object.isParsedByMl
                                        })
                                    })
                                ]
                            })
                        }),
                        props.priceSection
                    ]
                }),
                /*#__PURE__*/ _jsx(StickySection, {
                    className: "new-col"
                })
            ]
        })
    });
};
export default ProductDetailInfo;
